import {useEffect} from 'react';
import {Platform} from 'react-native';
import {TEST_ID} from 'react-native-gifted-chat';

//THIS HOOK IS USED TO TRIGGER LAYOUT ON CHAT IN WEB FIXES A BUG IN GIFTED-CHAT FOR WEB
//RELATED TO THE FACT THAT REACT NATIVE FOR WEB HAS NO AUTOLAYOUT ON VIEW TRANSITION
export function useChatWebRefresh() {
  useEffect(() => {
    if (Platform.OS === 'web') {
      const gcLoadingContaineEl = document.querySelectorAll(
        `[data-testid="${TEST_ID.LOADING_WRAPPER}"]`,
      )[0] as HTMLElement;

      if (gcLoadingContaineEl) {
        gcLoadingContaineEl.style.display = 'none';
        setTimeout(() => {
          gcLoadingContaineEl.style.display = 'flex';
        }, 500);
      }
    }
  }, []);
}
